import React, { useState } from 'react';
import { Button, Card, Typography, Upload, Form } from 'antd';
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { UploadOutlined } from '@ant-design/icons';
import { uploadResume } from "../../../services/user.service";
import { CustomeNotification } from '../../../utils/NotificationUtility';
import { profileComplete } from '../../../services/common.service';
import { fileTypeAllow, weightageList } from '../../../utils/StaticDataUtility';
import { RcFile } from 'antd/es/upload/interface';
import { UserCacheUpdate } from "../../../state/actions/auth";
import { postHogCaptureAnalitics } from '../../../services/posthog';
const cardStyle: React.CSSProperties = { border: '2px dashed #979ec2', background: '#f7f8fa' };
const cardBodyStyle: React.CSSProperties = { paddingTop: '10px' };
const { Text} = Typography;
// export interface pageProps {
//     profile?: any;
// }
const HiringCardPage: React.FC<any> = (pageProps) => {
    const [form] = Form.useForm();
    const { showUploadBtn, updateUserCache, user } = pageProps;
    const [fileSizeError, setFileSizeError] = useState('');
    const [fileOptionShow, setFileOptionShow] = useState(true)
    const navigate = useNavigate();
    const OnResume = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        form.submit();
        return e?.file;

    };
    const onResumeSave = async (values: any) => {
        console.log(user)
        if (user && user._id) {
            const resume = await uploadResume(user._id, values);
            if (resume && resume.data) {
                postHogCaptureAnalitics('profile.resume_uploaded', { user_id: user._id });
                CustomeNotification('success', `Resume Uploaded Successfully!`);
                setFileOptionShow(false);
                // profileComplete(profileId, user.profile, weightageList['ResumeUpload']);
                const newPayload = {...user,  ...{profileUpdatedAt: new Date().toISOString() }};
                updateUserCache(newPayload);
            } else {
                CustomeNotification('error', `Somthing went worng! Please try again later.`);
            }
        }
    };
    const beforeFileUpload = (file: RcFile) => {
        const fileSizeMB = file.size / 1024 / 1024;
        const isLt2M = fileSizeMB < fileTypeAllow.resumeSize;
        if (!isLt2M) {
            setFileSizeError(`File size is ${fileSizeMB.toFixed(2)} MB. Only ${fileTypeAllow.resumeSize} MB is allowed.`);
        } else {
            setFileSizeError('');
        }
        return false;
    };


    const onFileRemove = (e: any) => {
        setFileSizeError('');
    }
    const dummyRequest = () => {
        setTimeout(() => {
            console.log("ok");
        }, 0);
    };

    return (
        <Form
            name="upload_resume"
            className="login-form"
            autoComplete="off"
            layout='vertical'
            form={form}
            onFinish={onResumeSave}
            encType='multipart/form-data'
        >
            <Card hoverable className="mt-3" style={cardStyle} bodyStyle={cardBodyStyle}>
                {!showUploadBtn && <>
                    <Typography.Title className="mt-1 mb-0" level={4}>WE ARE</Typography.Title>
                    <Typography.Title className="mt-0 mb-1" level={2} style={{color: '#3399ff'}}>HIRING!</Typography.Title>
                    <Typography.Text className="mt-4 mb-1">Let’s work together and explore opportunities. </Typography.Text>
                    <Typography.Text className="mt-4 mb-1">Get updates in your mailbox as soon a matching job is published!</Typography.Text>
                </>}
                {fileOptionShow ?
                <div className='TextCenter'>                    
                    <Form.Item
                        className='mb-3 mt-6'
                        name="file_name"
                        valuePropName="file_name"
                        getValueFromEvent={OnResume}
                    >
                         <Upload accept={fileTypeAllow.resume} maxCount={1} multiple={false} name="logo" listType="picture" customRequest={dummyRequest} beforeUpload={beforeFileUpload} onRemove={onFileRemove}>
                                <Button icon={<UploadOutlined />} type="primary">Upload Resume</Button>
                                {fileSizeError && <><br /><Text type="danger">{fileSizeError}</Text> </>}
                         </Upload>
                    </Form.Item>
                    <Typography.Text className="mt-4 mb-1" style={{color: '#717b9e'}}>Supported Formats: doc, docx, pdf, upto 20 MB</Typography.Text>                         
                </div>
                :  <Typography.Title className="mt-0 mb-1" level={4} style={{color: '#52c41a'}}>Resume Uploaded Successfully!</Typography.Title>
                }
            </Card></Form>
    )
};

const mapStateToProps = (state: any) => {
    return { user: state.reducer.auth.user }
};

function mapDispatchToProps(dispatch: any) {
    return { updateUserCache: (payload: any) => dispatch(UserCacheUpdate(payload))};
}

export default connect(mapStateToProps, mapDispatchToProps)(HiringCardPage);